import type React from 'react';

import { cn } from '~/lib/cn';

type ContainerElement = 'div' | 'section' | 'main';

interface ContainerProps {
  children: React.ReactNode;
  as?: ContainerElement;
  className?: string;
  [key: string]: unknown;
}

function Container({ children, as: Tag = 'div', className, ...rest }: ContainerProps) {
  return (
    <Tag
      className={cn('mx-auto w-full', 'px-6 md:px-8 lg:px-12', 'max-w-[1440px]', className)}
      {...rest}
    >
      {children}
    </Tag>
  );
}

export { Container };
export type { ContainerProps };
export default Container;
